import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { ShopItem } from '@swyftx/features/shop/api/types';

import { cn } from '@shared/utils/lib/ui';

import { ShopItemVariantPicker } from './ShopItemVariantPicker';

type Props = {
  shopItem: ShopItem;
  selectedVariant: number;
  className?: string;
  setSelectedVariant: (selectedVariant: number) => void;
};

const ShopPreviewImageCard: React.FC<Props> = ({
  shopItem,
  className,
  selectedVariant,

  setSelectedVariant,
}) => (
  <FlexLayout
    direction='column'
    className='flex w-full justify-between rounded-16 bg-color-background-surface-secondary p-16'
  >
    <img
      data-testid={`${shopItem.id}.image`}
      id={`${shopItem.id}.image`}
      src={shopItem.variants[selectedVariant].imgSrc}
      alt={shopItem.title}
      className={cn('object-contain', className)}
    />
    <ShopItemVariantPicker
      id={shopItem.id}
      variants={shopItem.variants}
      selectedVariant={selectedVariant}
      setSelectedVariant={setSelectedVariant}
    />
  </FlexLayout>
);

export { ShopPreviewImageCard };
